/* eslint-disable max-len */
/* eslint-disable default-case */
import React from "react";
import ItemizeGroupTag from "./ItemizeGroupTag";

interface CareerTypeTagProps {
    careerTypeId: string | number;
}

const ItemizeCareerTypeTag = (props: CareerTypeTagProps) => <ItemizeGroupTag careerTypeId={props.careerTypeId} />;

export default ItemizeCareerTypeTag;
